import Head from 'next/head'
import { useRouter } from 'next/router'
import { WEBSITE_HOST } from '~/configs'

export const SEOHead: React.FC<{
  title?: string | number | null
  desc?: string | null
}> = ({ title, desc }) => {
  const router = useRouter()

  const isHome = router.pathname === '/'

  return (
    <Head>
      <title>
        {isHome || !title
          ? '无界版图-把数字版权装进口袋'
          : `${title} | 无界版图`}
      </title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        name="description"
        content={
          desc
            ? desc
            : '无界版图是用区块链技术为艺术作品提供安全可靠易用的数字版权登记和拍卖平台，致力于为艺术家、创作者提供数字作品的登记、版权保护、使用与拍卖的一整套解决方案。全面整合全球优质照片、图片、插画、矢量图、视频等资源，结合区块链技术在资产确权、拍卖方面的优势，为新媒体、设计、广告、各类垂直行业及个人用户提供优质数字版权。'
        }
      />
      <link rel="canonical" href={WEBSITE_HOST + router.asPath} />
      {isHome && (
        <meta
          name="keywords"
          content="无界版图,数字版权,版权拍卖,数字艺术,AI绘画,创作者经济,元宇宙"
        />
      )}
    </Head>
  )
}
